import React from "react"
import { Redirect } from "react-router-dom"

// // Pages Component
import Chat from "../pages/Chat/Chat"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Pages Calendar
import Calendar from "../pages/Calendar/index"

// //Tasks
import TasksList from "../pages/Tasks/tasks-list"
import TasksCreate from "../pages/Tasks/tasks-create"

// Journal 
import Journal from "../pages/Journal/journal-log"

//Invoices
import InvoicesList from "../pages/Invoices/invoices-list"
import InvoiceDetail from "../pages/Invoices/invoices-detail"

import Home from "../pages/home"
import Observe from "../pages/Observe/index"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

import PlantStore from "../pages/PlantStore/index"
import Admin from "../pages/Admin/admin"

// Resources
import Resources from "../pages/Resources/resources"
import Goals from "../pages/Goals/goals"
import PlantList from "../pages/PlantList/plants"
import PlantsInventory from "../pages/PlantList/plants-inventory"
import PlantsAreas from "../pages/PlantList/plants-areas"
import PlantsCustom from "../pages/PlantList/plants-custom"
import PlantsGuild from "../pages/PlantList/plants-guild"
import PlantsCropPlanner from "../pages/PlantList/plants-crop-planner"
import PlantsLogHarvest from "../pages/PlantList/plants-log-harvest"
import Hackathon from "../pages/Hackathon/hackathon"
import Leaderboard from "../pages/Hackathon/leaderboard"
// Charts
import ChartApex from "../pages/Charts/Apexcharts"
import ChartistChart from "../pages/Charts/ChartistChart"
import ChartjsChart from "../pages/Charts/ChartjsChart"
import SparklineChart from "../pages/Charts/SparklineChart"
import ChartsKnob from "../pages/Charts/charts-knob"

// Maps
import MapsVector from "../pages/Maps/MapsVector"

import Designer from "../pages/Design/Designer"

//Icons
import IconBoxicons from "../pages/Icons/IconBoxicons"
import IconDripicons from "../pages/Icons/IconDripicons"
import IconFontawesome from "../pages/Icons/IconFontawesome"

import DesignWizard from "../pages/Design/crop-planner"
import BuildGuild from "../pages/Design/build-guild"
//Ui
import UiAlert from "../pages/Ui/UiAlert"
import UiButtons from "../pages/Ui/UiButtons"
import UiCards from "../pages/Ui/UiCards"
import UiCarousel from "../pages/Ui/UiCarousel"
import UiColors from "../pages/Ui/UiColors"
import UiDropdown from "../pages/Ui/UiDropdown"
import UiGeneral from "../pages/Ui/UiGeneral"
import UiGrid from "../pages/Ui/UiGrid"
import UiImages from "../pages/Ui/UiImages"
import UiLightbox from "../pages/Ui/UiLightbox"
import UiModal from "../pages/Ui/UiModal"
import UiProgressbar from "../pages/Ui/UiProgressbar"
import UiSweetAlert from "../pages/Ui/UiSweetAlert"
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions"
import UiTypography from "../pages/Ui/UiTypography"
import UiVideo from "../pages/Ui/UiVideo"
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout"
import UiImageCropper from "../pages/Ui/ui-image-cropper"
import DesignGallery from "../pages/Gallery/design-gallery"
import Referrals from "../pages/Affiliate/referral"

import AccountIssue from "../pages/Authentication/AccountIssue";
//Pages
import PagesStarter from "../pages/Utility/pages-starter"
import PagesMaintenance from "../pages/Utility/pages-maintenance"
import PagesComingsoon from "../pages/Utility/pages-comingsoon"
import PagesTimeline from "../pages/Utility/pages-timeline"
import PagesFaqs from "../pages/Utility/pages-faqs"
import PagesPricing from "../pages/Utility/pages-pricing"
import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"

const userRoutes = [

  { path: "/home", component: Home },
  { path: "/observe", component: Observe },
  { path: "/plantstore", component: PlantStore },
  { path: "/admin", component: Admin },

  // gallery
  { path: "/gallery", component: DesignGallery },

  // //calendar
  { path: "/calendar", component: Calendar },

  // //profile
  { path: "/profile", component: UserProfile },

  // affiliate
  { path: "/referrals", component: Referrals },

  //Invoices
  { path: "/invoices-list", component: InvoicesList },
  { path: "/invoices-detail", component: InvoiceDetail },
  { path: "/invoices-detail/:id", component: InvoiceDetail },

  // Tasks
  { path: "/tasks-list", component: TasksList },
  { path: "/tasks-create", component: TasksCreate },

  // Resources
  { path: "/resources", component: Resources },

  // Goals
  { path: "/goals", component: Goals },	
  { path: "/plantlist", component: PlantList },
  { path: "/plants/inventory", component: PlantsInventory },
  { path: "/plants/areas", component: PlantsAreas },
  { path: "/plants/custom-plant", component: PlantsCustom },
  { path: "/plants/guild", component: PlantsGuild },
  { path: "/plants/crop-planner", component: PlantsCropPlanner },
  { path: "/plants/log-harvest", component: PlantsLogHarvest },
  { path: "/hackathon", component: Hackathon },
  { path: "/leaderboard", component: Leaderboard},

  // Journal
  { path: "/journal", component: Journal },


  //Charts
  { path: "/apex-charts", component: ChartApex },
  { path: "/chartist-charts", component: ChartistChart },
  { path: "/chartjs-charts", component: ChartjsChart },
  { path: "/sparkline-charts", component: SparklineChart },
  { path: "/charts-knob", component: ChartsKnob },

  // Icons
  { path: "/icons-boxicons", component: IconBoxicons },
  { path: "/icons-dripicons", component: IconDripicons },
  { path: "/icons-fontawesome", component: IconFontawesome },

  // Maps
  { path: "/maps-vector", component: MapsVector },

  { path: "/build-guild", component: BuildGuild },
  { path: "/designer", component: Designer },


  // Ui
  { path: "/ui-alerts", component: UiAlert },
  { path: "/ui-buttons", component: UiButtons },
  { path: "/ui-cards", component: UiCards },
  { path: "/ui-carousel", component: UiCarousel },
  { path: "/ui-colors", component: UiColors },
  { path: "/ui-dropdowns", component: UiDropdown },
  { path: "/ui-general", component: UiGeneral },
  { path: "/ui-grid", component: UiGrid },
  { path: "/ui-images", component: UiImages },
  { path: "/ui-lightbox", component: UiLightbox },
  { path: "/ui-modals", component: UiModal },
  { path: "/ui-progressbars", component: UiProgressbar },
  { path: "/ui-sweet-alert", component: UiSweetAlert },
  { path: "/ui-tabs-accordions", component: UiTabsAccordions },
  { path: "/ui-typography", component: UiTypography },
  { path: "/ui-video", component: UiVideo },
  { path: "/ui-session-timeout", component: UiSessionTimeout },
  { path: "/ui-image-cropper", component: UiImageCropper },

  //Utility
  { path: "/pages-starter", component: PagesStarter },
  { path: "/pages-timeline", component: PagesTimeline },
  { path: "/pages-faqs", component: PagesFaqs },
  { path: "/pages-pricing", component: PagesPricing },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/home" /> },
]

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/crop-planner", component: DesignWizard },
  { path: "/register", component: Register },
  { path: "/register/success", component: Register },
  { path: "/register/cancel", component: Register },
  { path: "/account-issue", component: AccountIssue },

  { path: "/pages-maintenance", component: PagesMaintenance },
  { path: "/pages-comingsoon", component: PagesComingsoon },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },
  { path: "/referrals", component: Referrals },
]

export { userRoutes, authRoutes }
